import type {GroupSingleOption} from '@pb/kit-component-modal-options';

export const prepareGroupsCheckboxTree = (groups: GroupSingleOption[], showHidden = false) => {
    return groups.map(groupSingle => {
        if (!groupSingle.hidden || groupSingle.hidden === showHidden) {
            return {
                caption: groupSingle.option.label,
                id: groupSingle.option.optionId,
            };
        }
        return null;
    }).filter(Boolean);
};
